module.exports = __webpack_public_path__ + "fonts/232725fa0697ac1e1a0a4a6816e0acb8-Roboto-Black.ttf";